import { render, staticRenderFns } from "./ReportedCoupons.vue?vue&type=template&id=7b78695a&"
import script from "./ReportedCoupons.vue?vue&type=script&lang=js&"
export * from "./ReportedCoupons.vue?vue&type=script&lang=js&"
import style0 from "./ReportedCoupons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports